<template>
  <div id="app">
    <router-view :key="routeReloadKey" />
    <ConfirmDialog :modal="true"/>
    <div class="loading-view" :modal="true" v-if="loading">
      <div class="loading-box" v-if="loadingMessage !== ''">
        <div>
          <ProgressSpinner style="width:50px;height:50px; visibility: hidden;" strokeWidth="5" />
          <pre>{{ loadingMessage }}</pre>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ConfirmDialog from 'primevue/confirmdialog'
import ProgressSpinner from 'primevue/progressspinner'
import { useConfirm } from 'primevue/useconfirm'
import { registerConfirm } from '@/utils/confirmProxy'

export default {
  setup() {
    const confirm = useConfirm()
    registerConfirm(confirm)
  },
  data() {
    return {
      routeReloadKey: 0,
    }
  },

  components: {
    ConfirmDialog,
    ProgressSpinner,
  },
  computed: {
    ...mapGetters(['loading', 'loadingMessage']),
    injectedSessionIdentity() {
      const { sessionKey, sessionToken } = this.$store.state
      if (!sessionKey || !sessionToken || sessionKey === 'null' || sessionToken === 'null') {
        return null
      }
      return JSON.stringify([sessionKey, sessionToken])
    },
  },
  watch: {
    $route: {
      handler(to) {
        let payload = {}
        if (to.path === '/tax') {
          if (to.query.title !== null && to.query.title !== undefined) {
            sessionStorage.setItem('localtitle', to.query.title)
          }
          payload = { title: `${sessionStorage.getItem('localtitle')}地方稅`, headerType: to.meta.headerType }
        } else if (to.path !== '/tax') {
          payload = { title: to.name, headerType: to.meta.headerType }
        }
        this.$store.dispatch('sentApp', {
          action: 'configureAppWebPage',
          payload: payload,
        })
      },
      immediate: true, 
    },
    
    injectedSessionIdentity(newVal, oldVal) {
      if (newVal && oldVal && newVal !== oldVal) {
        this.routeReloadKey += 1
      }
    },
  },
}
</script>

<style scoped></style>
